"use client";

import React from "react";
import GSTR3BSimulation from "../../components/GSTR3BSimulation";

export default function GSTR3BPage() {
  return (
    <div>
      <GSTR3BSimulation />
    </div>
  );
}
